<template>
  <div class="paybridge-wrap">
    <div class="paybridge-panel">
      <header class="panel-head">
        <span class="badge">PayBridge</span>
        <h3 class="panel-title">{{ acknowledged ? 'บัญชีโอนเงินของรายการนี้' : 'อ่านก่อนรับบัญชีโอนเงิน' }}</h3>
        <p class="panel-subtitle">{{ acknowledged ? 'โอนยอดตามนี้ แล้วอัปโหลดสลิปทันที' : 'ทำตามเงื่อนไขทั้ง 4 ข้อเพื่อให้เครดิตเข้าถูกต้อง' }}</p>
      </header>

      <section class="critical-warning">
        <div class="warning-head">
          <span>สำคัญมาก ก่อนโอนเงิน</span>
        </div>
        <div class="warning-grid">
          <div class="warning-item"><b>1</b><span><strong>ห้ามฝากซ้ำบัญชีเดิม</strong><small>บัญชีนี้ใช้ได้ครั้งเดียวสำหรับรายการนี้</small></span></div>
          <div class="warning-item"><b>2</b><span><strong>ฝากภายในเวลา</strong><small>หมดเวลาแล้วห้ามโอนเด็ดขาด</small></span></div>
          <div class="warning-item"><b>3</b><span><strong>ฝากตรงกับยอด</strong><small>ห้ามโอนขาดหรือเกินแม้แต่บาทเดียว</small></span></div>
          <div class="warning-item"><b>4</b><span><strong>ผิดเงื่อนไขไม่รับผิดชอบ</strong><small>โปรดตรวจสอบบัญชี ยอด และเวลาก่อนโอน</small></span></div>
        </div>
        <div class="warning-footer">หลังโอนแล้วให้อัปโหลดสลิปทันทีเพื่อยืนยันรายการ</div>
      </section>

      <section v-if="!acknowledged" class="agreement">
        <button type="button" class="primary-button" :disabled="cancelling" @click="$emit('acknowledge')"><i class="fas fa-check-circle"></i> รับทราบและแสดงบัญชีโอนเงิน</button>
        <button type="button" class="release-button" :disabled="cancelling" @click="$emit('cancel')">
          <i class="fas fa-ban"></i> {{ cancelling ? 'กำลังยกเลิก...' : 'ยกเลิกรายการ PayBridge' }}
        </button>
        <button type="button" class="cancel-button" data-dismiss="modal">ปิดหน้าต่าง</button>
      </section>

      <section v-else>
        <div class="amount-card">
          <div class="amount-copy">
            <span>ยอดที่ต้องโอน</span>
            <strong>{{ Number(amount || 0).toLocaleString('th-TH') }} บาท</strong>
          </div>
          <div class="timer">
            <small>เวลาคงเหลือ</small>
            <strong>{{ remainingText || '0:00' }}</strong>
          </div>
        </div>
        <div class="account-card">
          <img :src="bankImage" alt="PayBridge bank">
          <div>
            <span class="bank-name">{{ account.bankName || account.bankCode || 'ธนาคาร' }}</span>
            <strong class="account-name">{{ account.accountName }}</strong>
            <div class="account-number">{{ account.accountNo }}</div>
          </div>
        </div>
        <input ref="fileInput" class="file-input" type="file" accept="image/*" @change="$emit('upload', $event)">
        <button type="button" class="primary-button upload" :disabled="cancelling" @click="$refs.fileInput.click()"><i class="fas fa-cloud-upload-alt"></i> อัปโหลดสลิป PayBridge</button>
        <button type="button" class="release-button" :disabled="cancelling" @click="$emit('cancel')">
          <i class="fas fa-ban"></i> {{ cancelling ? 'กำลังยกเลิก...' : 'ยกเลิกรายการ PayBridge' }}
        </button>
        <button type="button" class="cancel-button" data-dismiss="modal">ปิดหน้าต่าง</button>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PayBridgeDepositPanel',
  props: {
    match: { type: Object, required: true },
    amount: { type: Number, default: 0 },
    acknowledged: { type: Boolean, default: false },
    remainingText: { type: String, default: '' },
    bankImage: { type: String, default: '' },
    cancelling: { type: Boolean, default: false },
  },
  computed: { account() { return this.match.recipientAccount || {}; } },
};
</script>

<style scoped>
.paybridge-wrap { padding: 18px 14px; }
.paybridge-panel { width: min(100%, 620px); margin: 0 auto; padding: 15px; color: #122630; background: #f8fdff; border: 1px solid #bce8f1; border-radius: 8px; box-shadow: 0 14px 34px rgba(6,54,79,.16); }
.panel-head { padding: 14px; text-align: center; background: #fff; border: 1px solid #d8eef3; border-radius: 7px; }
.badge { display: inline-flex; padding: 7px 13px; color: #fff; background: #087f9b; border-radius: 5px; font-size: 13px; font-weight: 900; }
.panel-title { margin: 10px 0 4px; font-size: 23px; line-height: 1.3; }
.panel-subtitle { margin: 0; color: #627780; font-size: 15px; line-height: 1.45; }
.critical-warning { margin-top: 12px; padding: 12px; color: #7f1d1d; background: #fff5f5; border: 2px solid #dc3545; border-radius: 7px; font-size: 15px; }
.warning-head { font-size: 16px; font-weight: 900; }
.warning-grid { margin-top: 10px; display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }
.warning-item { min-height: 64px; padding: 9px; display: grid; grid-template-columns: 30px 1fr; gap: 9px; background: #fff; border: 1px solid #f5b8bd; border-radius: 6px; }
.warning-item > b { width: 28px; height: 28px; display: grid; place-items: center; color: #fff; background: #dc3545; border-radius: 4px; font-size: 15px; }
.warning-item strong, .warning-item small { display: block; text-align: left; line-height: 1.35; }
.warning-item strong { font-size: 15px; }
.warning-item small { margin-top: 2px; color: #8f4a4f; font-size: 13px; }
.warning-footer { margin-top: 9px; font-size: 15px; font-weight: 850; text-align: center; }
.agreement { margin-top: 12px; }
.amount-card { margin-top: 12px; padding: 13px; display: flex; align-items: center; justify-content: space-between; color: #fff; background: #0b5268; border-radius: 7px; }
.amount-copy span, .amount-copy strong { display: block; text-align: left; }
.amount-copy span { font-size: 15px; }
.amount-copy strong { font-size: 24px; line-height: 1.25; }
.timer { min-width: 92px; padding: 8px 11px; color: #083746; background: #e9fbff; border-radius: 6px; text-align: center; font-variant-numeric: tabular-nums; }
.timer small, .timer strong { display: block; }
.timer small { font-size: 12px; font-weight: 700; line-height: 1.2; }
.timer strong { margin-top: 2px; font-size: 19px; font-weight: 900; line-height: 1.1; }
.account-card { margin-top: 10px; padding: 13px; display: grid; grid-template-columns: 54px 1fr; align-items: center; gap: 12px; background: #fff; border: 1px solid #ccebf2; border-radius: 7px; text-align: left; }
.account-card img { width: 54px; height: 54px; object-fit: contain; }
.bank-name, .account-name { display: block; }
.bank-name { font-size: 14px; }
.account-name { font-size: 16px; line-height: 1.35; }
.account-number { margin-top: 4px; color: #087f9b; font-size: 23px; font-weight: 900; word-break: break-all; }
.primary-button, .release-button, .cancel-button { width: 100%; min-height: 52px; margin-top: 11px; border: 0; border-radius: 6px; font-size: 17px; font-weight: 900; }
.primary-button { color: #fff; background: #078660; }
.release-button { color: #fff; background: #b4232d; }
.release-button:disabled { cursor: wait; opacity: .65; }
.cancel-button { color: #a6212b; background: #fff1f2; border: 1px solid #f2bbc0; }
.file-input { display: none; }
@media (max-width: 575px) { .warning-grid { grid-template-columns: 1fr; } .amount-card { align-items: stretch; flex-direction: column; gap: 10px; } .timer { align-self: flex-start; } }
</style>
